import React from "react";
import ScoreBox from "../components/ScoreBox";
import ScorePercentDisplay from "../components/ScorePercentDisplay";
// import ScorePercentDisplayBG from "../components/ScorePercentDisplayBG";
import { HashLink as Link } from "react-router-hash-link";
import CreatePDF from "./CreatePDF";
// import BalanceSheet from "./BalanceSheet";
import ConvertTimeStamp from "../Utils/ConvertTimeStamp";
// import StripeButton from "../components/StripeButton";
import SelectPlan from "./SelectPlan";

function ScoreBreakDown(props) {
  const currentKey = props.currentKey;
  const Scores = props.activeProfile.History[currentKey].Scores;
  const Reports = props.activeProfile.History[currentKey].Reports;
  // console.log("Scores :>> ", Scores);
  // console.log("props.activeProfile :>> ", props.activeProfile);
  const MAXTotal = Scores.MaxTotal;
  const MAXD = Scores.Defense.Max.Total;
  const MAXO = Scores.Offense.Max.Total;
  //const MAXE = 500;
  //console.log(`Reports: ${JSON.stringify(Reports)}`);
  const pdfName = props.activeProfile.Name;
  const displayDate = ConvertTimeStamp(currentKey);
  //  console.log("Reports:", Reports);
  //   console.log("Subbed:", props.Subscribed);
  // console.log("Score Breakdown props.Quotes :>> ", props.Quotes);
  return (
    <div>
      {props.Dev === undefined || props.Dev === true ? (
        <div>
          <div className="hoverBox OverviewContainer">
            <div id="summary">
              <h2>{props.label} Date:</h2>
              On {displayDate.toString().split("-")[0]}, at{" "}
              {displayDate.toString().split("-")[1]}
              <br />
              <div className="OverviewSub">
                <div className="OverviewItem">
                  <Link to="#Defense">
                    <ScorePercentDisplay
                      curValue={Scores.Defense.TotalScore}
                      maxValue={MAXD}
                      chartType={"Defense"}
                    />
                  </Link>
                </div>
                <div className="OverviewItem">
                  <h1> + </h1>
                </div>

                <div className="OverviewItem">
                  <Link to="#Offense">
                    <ScorePercentDisplay
                      curValue={Scores.Offense.TotalScore}
                      maxValue={MAXO}
                      chartType={"Offense"}
                    />
                  </Link>
                </div>

                {props.activeProfile.History[currentKey].Scores.Efficiency !==
                  0 && (
                  <div className="OverviewItem">
                    <h1> - </h1>
                  </div>
                )}
                {props.activeProfile.History[currentKey].Scores.Efficiency !==
                  0 && (
                  <div
                    className="OverviewItem"
                    style={{
                      display: "inline-block",
                    }}
                  >
                    <div>
                      <h3>
                        {
                          props.activeProfile.History[currentKey].Scores
                            .Efficiency
                        }
                      </h3>
                      <h3>Efficiency</h3>(
                      {
                        props.activeProfile.History[currentKey].Scores
                          .Efficiency
                      }{" "}
                      pt deduction)
                    </div>
                  </div>
                )}
                <div
                  className="OverviewItem"
                  // style={{ height: 150, margin: "auto" }}
                >
                  <h1> = </h1>
                </div>
                <div className="OverviewItem">
                  <Link to="#Total">
                    <ScorePercentDisplay
                      curValue={
                        props.activeProfile.History[currentKey].Scores.Total
                      }
                      maxValue={MAXTotal}
                      chartType={"Total"}
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "block",
                padding: "3%",
                margin: "auto",
                width: "80%",
              }}
            >
              {Reports === "Unpaid" ? (
                <></>
              ) : (
                <CreatePDF
                  Quotes={props.Quotes}
                  logo={props.logo.pdf}
                  pdfName={pdfName}
                  pdfDate={currentKey}
                  Info={props.activeProfile.History[currentKey]}
                ></CreatePDF>
              )}
            </div>
          </div>
          <br />
        </div>
      ) : (
        <></>
      )}
      <div className="OverviewContainer">
        <div id="Total">
          <ScoreBox
            header={"Your Overall Score"}
            desc={
              "Your Overall score is the culmination of each section total, summed up into one, easy to read score."
            }
            Scores={props.activeProfile.History[currentKey].Scores}
            type={"Total"}
            Dev={props.Dev}
          ></ScoreBox>
        </div>
      </div>
      <br />
      <div className="OverviewContainer">
        <div id="Defense">
          <ScoreBox
            header={"Your Defense Score"}
            desc={
              "This number is your overall score for financial components that PROTECT your standing."
            }
            Scores={props.activeProfile.History[currentKey].Scores}
            type={"Defense"}
            Dev={props.Dev}
          ></ScoreBox>
        </div>
      </div>
      <br />
      <div className="OverviewContainer">
        <div id="Offense">
          <ScoreBox
            header={"Your Offense Score"}
            desc={
              "This number is your overall score for financial components that GROW your standing."
            }
            Scores={props.activeProfile.History[currentKey].Scores}
            type={"Offense"}
            Dev={props.Dev}
          ></ScoreBox>
        </div>
      </div>
      <br />
      <div className="OverviewContainer">
        <div id="Efficiency">
          <br />
          <ScoreBox
            header={"Your Efficiency Score"}
            desc={
              "This number is your overall score for financial components that OPTIMIZE your standing."
            }
            Scores={props.activeProfile.History[currentKey].Scores}
            type={"Efficiency"}
            Dev={props.Dev}
          ></ScoreBox>
        </div>
      </div>
      <br />
      {Reports === "Unpaid" ? (
        <SelectPlan
          label="Get your full QFP Score here"
          UserID={props.UserID}
          currentProfileIdx={props.currentProfileIdx}
          currentKey={currentKey}
        ></SelectPlan>
      ) : (
        <CreatePDF
          logo={props.logo.pdf}
          Quotes={props.Quotes}
          pdfName={pdfName}
          pdfDate={currentKey}
          Info={props.activeProfile.History[currentKey]}
        ></CreatePDF>
      )}
      {/* 
      {Reports === "Unpaid" && props.Subscribed === false ? (
        <></>
      ) : (
        <div className="hoverBox OverviewContainer">
          <BalanceSheet
            BalanceSheet={
              props.activeProfile.History[currentKey].Reports.BalanceSheet
            }
          />
        </div>
      )} */}
    </div>
  );
}

export default ScoreBreakDown;
